import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Markdown from '../../components/atoms/Markdown/Markdown';

import {
  BookATourConfirmationPageContainer,
  BookATourConfirmationPageInnerContainer,
  BookATourConfirmationPageLeftColumn,
  BookATourConfirmationPageLeftColumnInner,
  BookATourConfirmationPageRightColumn,
  LogoContainer,
  Photo,
  Logo,
  LogoTitle,
  LogoSubTitle,
  LogoDescription,
  TourRequestSubmittedText,
} from './BookATourConfirmationPage.css.js';

class BookATourConfirmationPage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      header,
      page,
    } = this.props.content;

    return (
      <BookATourConfirmationPageContainer>
        <BookATourConfirmationPageInnerContainer>
          <BookATourConfirmationPageLeftColumn>
            <BookATourConfirmationPageLeftColumnInner
              hasPhoto={!!page.photo}
            >
              {!!page.photo && (<Photo
                src={page.photo}
                alt={!!page.photoText ? page.photoText : `c'e Montessori - Tours`}
              />)}

              <LogoContainer
                hasPhoto={!!page.photo}
              >
                <Logo
                  src={`/images/ce-montessori/logos/ce-montessori-logo-horizontal-white-text.png`}
                  alt={`c'e Montessori - Logo`}
                />
              
                {page.logoTitle && (<LogoTitle>{page.logoTitle}</LogoTitle>)}
  
                {page.logoSubTitle && (<LogoSubTitle>{page.logoSubTitle}</LogoSubTitle>)}
  
                {page.logoDescription && (<LogoDescription>{page.logoDescription}</LogoDescription>)}
              </LogoContainer>
            </BookATourConfirmationPageLeftColumnInner>
          </BookATourConfirmationPageLeftColumn>
          
          <BookATourConfirmationPageRightColumn>
            <TourRequestSubmittedText>{page.completeTitle}</TourRequestSubmittedText>

            <Markdown body={page.completeDescription} />
          </BookATourConfirmationPageRightColumn>
        </BookATourConfirmationPageInnerContainer>
      </BookATourConfirmationPageContainer>
    );
  }
}

BookATourConfirmationPage.propTypes = {
  config: PropTypes.shape({
    hasHeader: PropTypes.bool.isRequired,
  }),
  content: PropTypes.shape({
    header: {
      config: PropTypes.shape({
        showLogo: PropTypes.bool,
      }),
      content: PropTypes.shape({
        navigationItems: PropTypes.shape({
          label: PropTypes.string.isRequired,
          link: PropTypes.string.isRequired,
        }).isRequired,
      }),
    },
    page: PropTypes.shape({
      photo: PropTypes.string,
      photoText: PropTypes.string,
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      featuredImage: PropTypes.string,
    }).isRequired,
  }),
};

BookATourConfirmationPage.defaultProps = {
  config: {
    hasHeader: true,
  },
};

export default BookATourConfirmationPage;